import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getApiUrl } from './config';

function Navbar({ toggleSidebar }) {
    const navigate = useNavigate();
    const [summary, setSummary] = useState({ daily_sale: 0, daily_purchase: 0 });

    useEffect(() => {
        const fetchSummary = async () => {
            try {
                const res = await axios.get(`${getApiUrl()}/dashboard/summary`);
                setSummary(res.data);
            } catch (err) {
                console.error(err);
            }
        };
        fetchSummary();
        const interval = setInterval(fetchSummary, 60000); // Update every minute
        return () => clearInterval(interval);
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/');
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark py-1">
            <div className="container-fluid">
                <button className="btn btn-outline-light me-2 d-md-none" onClick={toggleSidebar}>
                    <i className="bi bi-list"></i>
                </button>
                <Link className="navbar-brand" to="/dashboard">Billing System</Link>
                
                <div className="flex-grow-1 mx-3 overflow-hidden d-none d-md-block">
                    {/* eslint-disable-next-line jsx-a11y/no-distracting-elements */}
                    <marquee behavior="scroll" direction="left" className="text-white mt-2">
                        <span className="me-5">Today's Sale: <strong>₹ {(summary.daily_sale || 0).toFixed(2)}</strong></span>
                        <span className="me-5">Today's Purchase: <strong>₹ {(summary.daily_purchase || 0).toFixed(2)}</strong></span>
                        <span className="me-5 text-warning fw-bold">Welcome to your Billing Dashboard! Stay updated with real-time totals.</span>
                    </marquee>
                </div>

                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item">
                            <button className="btn btn-sm btn-outline-light" onClick={handleLogout}>Logout</button>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
